import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';



@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class Reflex9 extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;

  isBack: boolean = true;
  seletedFoot: string = ReflexFoot.Plastik;
  seletedArmletType: string = ReflexdArmletType.Adjustable;

  product: ProductDefinition;

  defHideObjects = [
    '_yyy',
    'kolcak_plastik',
  ];

  defShowObjects =  [
    'xxx_reflex_alt_yyy',
    'reflex_9_sirt_yyy',
    'xxx_reflex_kolcak_sag_yyy',
    'xxx_reflex_kolcak_sol_yyy',
    'reflex_ayak_plastik_yyy',
    'xxx_reflex_kolcak_dugme_yyy',
    'xxx_reflex_donati_yyy',
    'reflex_kolcak_demir_genisliksiz_plastik_yyy',
    'reflex_tansiyon_kizaksiz_yyy',
    'reflex_donati_kizaksiz_kasa_yyy',
    'reflex_9_sirt_destegi_yyy',
    'reflex_9_sirt_cita_yyy',
    'xxx_reflex_kolcak_dugme_sol_yyy',
    'xxx_reflex_kolcak_dugme_sag_yyy',
    'xxx_reflex_donati_yyy',
    'xxx_reflex_donati_pedal_sol_yyy',
    'xxx_reflex_donati_pedal_sag_yyy',
    'reflex_9_sirt_cita_plastik_yyy',
    'reflex_9_destek_tuslar',
  ];

  availableAnimations: AnimationDefinition[] = [];
  async created()
  {
    this.product = Store.getProductById('reflex9');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes, ['order'], ['asc']);
    this.availableAnimations = this.product.animations as AnimationDefinition[];
    this.availableAnimationsChanged();
    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });
    if (Store.state.selection)
    {
      Store.state.selection.parts.forEach((element) =>
      {
        this.colorChanged(element.color, element.palette, element.id);
      });
      if (Store.state.selection.footAndHand === ReflexFoot.Metal)
      {
        await this.changeFoot(ReflexFoot.Metal);

      }
      if (Store.state.selection.footAndHand === ReflexFoot.Plastik)
      {
        await this.changeFoot(ReflexFoot.Plastik);
        if (Store.state.selection.armletType === ReflexdArmletType.Constant)
        {
          await this.changeArmletType(ReflexdArmletType.Constant);
        }

      }
      if (Store.state.selection.isBack === false)
      {
        this.changeBack(false);
      }
    } else
    {
      await this.applyDefaultSelection();
    }

  }


  availableAnimationsChanged()
  {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }


  mounted()
  {
    // this.configuratorService = Store.state.configuratorService;

  }

  async applyDefaultSelection()
  {
    const selection = new Reflex9Selection();
    selection.parts = [];
    selection.footAndHand = ReflexFoot.Metal;
    selection.armletType = ReflexdArmletType.Adjustable;
    selection.isBack = true;

    this.product.defaults.parts.forEach((element) =>
    {
      this.colorChanged(element.color, element.palette, element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.palette = element.palette;
      part.name = element.name;
      selection.parts.push(part);
    });

    Store.state.selection = selection;
    this.changeFoot(ReflexFoot.Plastik);

  }

  async changeFoot(foot: ReflexFoot)
  {
    if (foot === ReflexFoot.Metal)
    {
      await this._configuratorService.hideObjects({ objects: ['reflex_9_sirt_cita_plastik_yyy', 'reflex_ayak_plastik_yyy', 'reflex_kolcak_demir_genisliksiz_plastik_yyy', 'kolcak_plastik'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['reflex_9_sirt_cita_metal_yyy', 'reflex_ayak_metal_yyy', 'reflex_kolcak_demir_genisliksiz_aluminyum_yyy', 'xxx_reflex_kolcak'], operator: FilterOperators.Contains });

      Store.state.selection.footAndHand = ReflexFoot.Metal;
      this.seletedFoot = ReflexFoot.Metal;
      Store.state.selection.armletType = ReflexdArmletType.Adjustable;
      this.seletedArmletType = ReflexdArmletType.Adjustable;
      this.updateAnimations();
    }
    if (foot === ReflexFoot.Plastik)
    {
      await this._configuratorService.hideObjects({ objects: ['reflex_ayak_metal_yyy', 'reflex_9_sirt_cita_metal_yyy', 'reflex_kolcak_demir_genisliksiz_aluminyum_yyy', 'kolcak_plastik'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['reflex_ayak_plastik_yyy', 'reflex_9_sirt_cita_plastik_yyy', 'reflex_kolcak_demir_genisliksiz_plastik_yyy', 'xxx_reflex_kolcak'], operator: FilterOperators.Contains });
      Store.state.selection.footAndHand = ReflexFoot.Plastik;
      this.seletedFoot = ReflexFoot.Plastik;
      if (Store.state.selection.armletType === ReflexdArmletType.Constant)
      {
        await this.changeArmletType(ReflexdArmletType.Constant);
      }
      this.updateAnimations();

    }

  }

  async changeBack(isBack: boolean)
  {
    if (isBack)
    {
      await this._configuratorService.showObjects({ objects: ['reflex_9_sirt_destegi_yyy', 'reflex_9_destek_tuslar_sag_yyy', 'reflex_9_destek_tuslar_sol_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.hideObjects({ objects: ['reflex_9_desteksiz_tuslar_sag_yyy', 'reflex_9_desteksiz_tuslar_sol_yyy'], operator: FilterOperators.Contains });
    }
    else
    {
      await this._configuratorService.showObjects({ objects: ['reflex_9_desteksiz_tuslar_sag_yyy', 'reflex_9_desteksiz_tuslar_sol_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.hideObjects({ objects: ['reflex_9_sirt_destegi_yyy', 'reflex_9_destek_tuslar_sag_yyy', 'reflex_9_destek_tuslar_sol_yyy'], operator: FilterOperators.Contains });
    }
    Store.state.selection.isBack = isBack;
    this.isBack = isBack;
    this.updateAnimations();

  }

  async changeArmletType(arm: ReflexdArmletType)
  {
    if (arm === ReflexdArmletType.Constant)
    {
      await this._configuratorService.showObjects({ objects: ['kolcak_plastik'], operator: FilterOperators.Contains });
      await this._configuratorService.hideObjects({ objects: ['reflex_kolcak_demir_genisliksiz_plastik_yyy', 'xxx_reflex_kolcak'], operator: FilterOperators.Contains });
      Store.state.selection.armletType = arm;
      this.seletedArmletType = arm;
      this.updateAnimations();
    }
    if (arm === ReflexdArmletType.Adjustable)
    {
      await this._configuratorService.showObjects({ objects: ['reflex_kolcak_demir_genisliksiz_plastik_yyy', 'xxx_reflex_kolcak'], operator: FilterOperators.Contains });
      await this._configuratorService.hideObjects({ objects: ['kolcak_plastik'], operator: FilterOperators.Contains });
      Store.state.selection.armletType = arm;
      this.seletedArmletType = arm;
      this.updateAnimations();
    }

  }

  updateAnimations()
  {
    let animations = [];

    if (this.seletedArmletType === ReflexdArmletType.Constant && this.isBack === false)
    {
      this.product.animations.forEach((element) =>
      {
        if (!(element.animationName === 'a7' || element.animationName === 'a1'))
        {
          animations.push(element);
        }
      });
    }

    else if (this.seletedArmletType === ReflexdArmletType.Adjustable && this.isBack === false)
    {
      this.product.animations.forEach((element) =>
      {
        if (!(element.animationName === 'a7'))
        {
          animations.push(element);
        }
      });
    }

    else if (this.seletedArmletType === ReflexdArmletType.Constant && this.isBack === true)
    {
      this.product.animations.forEach((element) =>
      {
        if (!(element.animationName === 'a1'))
        {
          animations.push(element);
        }
      });
    }

    else if (this.seletedArmletType === ReflexdArmletType.Adjustable && this.isBack === true)
    {
      animations = this.product.animations as any[];
    }

    this.availableAnimations = animations;
    this.availableAnimationsChanged();
  }

  async colorChanged(color: any, palette: any, part: any)
  {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });

    if (part === 'reflex_9_sirt')
    {

      const op: string = getColor.texture.split('.jpg')[0] + '_opacity.jpg';
      console.log(op);
      await this._configuratorService.changeOpacity({
        materials: getPart.materials,
        texture: op,
      });
      await this._configuratorService.changeBumpMap({
        materials: getPart.materials,
        texture: op,
      });
    }
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

}
export class Reflex9Selection
{
  parts: PartSelection[];
  footAndHand: ReflexFoot;
  armletType: ReflexdArmletType;
  isBack: boolean;
}
export class PartSelection
{
  id: string;
  palette: string;
  color: string;
  name: string;
}
enum ReflexFoot
{
  Metal = 'metal',
  Plastik = 'plastik',

}
enum ReflexdArmletType
{
  Constant = 'constant',
  Adjustable = 'adjustable',
}



// WEBPACK FOOTER //
// ./src/components/families/reflex/Reflex9.ts